module.exports = __webpack_public_path__ + "img/service-about-1.08932725.webp";